import { Box, Flex, Text } from '@indeed/ifl-components';
import { DataLineUp, DataLineDown } from '@indeed/ifl-icons';
import Heading from '../heading';
import { TextComponentProps } from '../../types';
import {
  i18nNumberFormat,
  i18nDateFormat,
  replaceMonthPlaceholder,
} from '../../utils/localizationUtils';

const TextStat: React.FC<TextComponentProps> = ({
  label,
  amount,
  change,
  date,
  description,
  info,
  localization,
}) => {
  return (
    <Box>
      <Heading
        text={label}
        tooltipText={info}
        tooltipLabel={`More information about ${label}`}
      />
      <Box>
        <Text level={5} sx={{ fontWeight: 'bold', color: 'foreground.strong' }}>
          {i18nNumberFormat(amount, localization.locale)}
        </Text>
        {change && (
          <Flex>
            <Box
              as="span"
              sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}
            >
              {change > 0 ? (
                <>
                  <DataLineUp
                    size="xs"
                    color="foreground.status.success"
                    sx={{ mr: 1 }}
                    aria-hidden
                  />
                  <Text
                    level={2}
                    sx={{
                      color: 'foreground.status.success',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    {`+${i18nNumberFormat(change, localization.locale)}`}
                  </Text>
                </>
              ) : (
                <>
                  <DataLineDown
                    size="xs"
                    color="foreground.status.critical"
                    sx={{ mr: 1 }}
                    aria-hidden
                  />
                  <Text level={2} sx={{ color: 'foreground.status.critical' }}>
                    {i18nNumberFormat(change, localization.locale)}
                  </Text>
                </>
              )}
            </Box>
            <Text level={2}>
              &nbsp;
              {replaceMonthPlaceholder(
                localization.sinceMonthFormat,
                date ? i18nDateFormat(date, localization.locale) : ''
              )}
            </Text>
          </Flex>
        )}
        <Box sx={{ mt: 2 }}>
          <Text>{description}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default TextStat;
